import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import SmallCopyBlock from '../blocks/SmallCopy'
import { GeoAlt } from 'react-bootstrap-icons';

function CardLocation(){
    return (
        <> 
            <Container>
                <Row>
                    <Col xs={{ span: 1 }}  className="text-start">
                        
                        <div><GeoAlt size={24} /></div>
                    </Col>
                    <Col xs={{ span: 10 }} className="text-start">
                        <div>
                        </div>
                        
                        <SmallCopyBlock styling=''>9115 FM 723 STE 600</SmallCopyBlock>
                        <SmallCopyBlock styling=''>Richmond, TX 77406</SmallCopyBlock>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default CardLocation;